import React from 'react';

export default ({ className, width = 128, height = 84 }) => (
  <svg height={height} viewBox="0 0 128 84" width={width} className={className}>
    <g fill="#000" transform="matrix(.13204 0 0 .12805 0 -20.065)">
      <path d="M969.4 216.7c0-33.1-26.9-60-60-60h-849.4c-33.1 0-60 26.9-60 60v82.5h969.4zM969.4 409.3h-969.4v343.4c0 33.1 26.9 60 60 60h849.4c33.1 0 60-26.9 60-60z"></path>
    </g>
  </svg>
);
